import { SignTitle, SvgIcon } from '@/components'
import { PageLoading } from '@/components/page-loading'
import { ContentLayout } from '@/layouts/content-layout'
import { useGetMenuList } from '@/pages/login/util'
import { Modal } from 'antd'
import { Suspense, useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'

import PhishingCreate from '@/pages/phishing/create'
import PhishingTaskList from '@/pages/phishing/activity'
import PhishingTaskDetail from '@/pages/phishing/task-detail'
import PhishingTemplate from '@/pages/phishing/template'
import PhishingTarget from '@/pages/phishing/target'
import PhishingCollection from '@/pages/phishing/mail-collect'
import { t } from '@/i18n'

export const FishingLayout = () => {
  const [isShow, setIsShow] = useState(false)
  const [getMenuList] = useGetMenuList()
  const [email, setEmail] = useState(false)
  const [phishing, setPhishing] = useState(false)
  const menuList = [
    {
      key: 'create',
      label: t('创建任务'),
      component: <PhishingCreate />,
    },
    {
      key: 'task',
      label: t('任务列表'),
      component: <PhishingTaskList />,
    },
    {
      key: 'task',
      label: t('任务详情'),
      component: <PhishingTaskDetail />,
      show: false,
      name: 'detail',
    },
    {
      key: 'template',
      label: t('模板资源'),
      component: <PhishingTemplate />,
    },
    {
      key: 'target',
      label: t('评估目标'),
      component: <PhishingTarget />,
    },
    ...(email
      ? [
          {
            key: 'collection',
            label: t('邮箱收集'),
            component: <PhishingCollection />,
          },
        ]
      : []),
  ]

  const onShow = () => {
    setIsShow(true)
  }

  const onHide = () => {
    setIsShow(false)
  }

  useEffect(() => {
    getMenuList()
      .then(res => {
        let obj = {}
        res?.data?.items.map(item => {
          obj[item?.name] = item?.checked
        })
        setEmail(obj['邮箱收集'] === 1)
        setPhishing(obj['钓鱼邮件'] === 1)
      })
      .catch(err => {})
  }, [])

  const rightSlot = (
    <div
      onClick={() => {
        onShow()
      }}
      className="description"
    >
      <SvgIcon name={'场景描述'} width={14} style={{ marginRight: '6px', height: 14 }} />
      <span>{t('场景描述')}</span>
    </div>
  )

  return (
    <>
      <ContentLayout menuList={menuList} rightSlot={rightSlot}>
        <Suspense fallback={<PageLoading />}>
          <Outlet />
        </Suspense>
      </ContentLayout>
      <Modal
        title={<SignTitle show>{t('场景描述')}</SignTitle>}
        visible={isShow}
        onCancel={onHide}
        footer={null}
        centered
      >
        <div
          className="title"
          style={{
            fontWeight: '500',
            fontSize: '14px',
            color: '#333333',
            marginBottom: '16px',
            marginLeft: '8px',
          }}
        >
          {t('验证对象')}
        </div>
        <div
          className="content"
          style={{
            fontSize: '14px',
            color: '#666666',
            marginBottom: '24px',
            marginLeft: '8px',
          }}
        >
          {t('人员安全意识')}
        </div>
        <div
          className="title"
          style={{
            fontWeight: '500',
            fontSize: '14px',
            color: '#333333',
            marginBottom: '16px',
            marginLeft: '8px',
          }}
        >
          {t('验证原理')}
        </div>
        <div
          className="content"
          style={{
            fontSize: '14px',
            color: '#666666',
            marginBottom: '24px',
            marginLeft: '8px',
          }}
        >
          {t(
            '面向评估目标用户发送钓鱼邮件，通过评估用户查看邮件、打开附件、点击链接、提交信息等行为进行目标安全意识评分。',
          )}
        </div>
        <div
          className="title"
          style={{
            fontWeight: '500',
            fontSize: '14px',
            color: '#333333',
            marginBottom: '16px',
            marginLeft: '8px',
          }}
        >
          {t('使用说明')}
        </div>
        <div
          className="content"
          style={{
            fontSize: '14px',
            color: '#666666',
            marginBottom: '24px',
            marginLeft: '8px',
          }}
        >
          <div className="item" style={{ display: 'flex', marginBottom: '8px' }}>
            <SvgIcon name={'纸飞机'} width={14} style={{ marginRight: '10px', height: '14px' }} />
            <span>{t('评估目标支持一键自动化收集企业暴露在互联网的邮箱账号.')}</span>
          </div>
          <div className="item" style={{ display: 'flex', marginBottom: '8px' }}>
            <SvgIcon
              name={'纸飞机'}
              width={14}
              height={14}
              style={{ marginRight: '10px', minWidth: '14px' }}
            />

            <span>
              {t(
                '钓鱼邮件支持钓鱼链接、恶意附件两种任务类型，内置丰富的模板资源，支持用户按需自定义。',
              )}
            </span>
          </div>
          <div className="item" style={{ display: 'flex', marginBottom: '8px' }}>
            <SvgIcon
              name={'纸飞机'}
              width={14}
              height={14}
              style={{ marginRight: '10px', minWidth: '14px' }}
            />

            <span>
              {t(
                '批量下发钓鱼邮件前，请先确认邮件接收的安全策略，确保发件服务器已添加至白名单，邮件接收正常。',
              )}
            </span>
          </div>
          <div className="item" style={{ display: 'flex', marginBottom: '8px' }}>
            <SvgIcon name={'纸飞机'} width={14} style={{ marginRight: '10px', height: '14px' }} />
            <span>{t('若用户识破钓鱼，可上报安全管理人员进行识破钓鱼标记。')}</span>
          </div>
        </div>
      </Modal>
    </>
  )
}
